<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-taxesreport">
    </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats" (click)="onTapToReload()"></salonmonster-tap-retry>


  <div margin-top *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats">

    <ion-row>
      <ion-col class="hidden-lg-down" size="2"></ion-col>
      <ion-col size="12" size-xl="8">
        <div style="height: 50vh;">
          <canvas baseChart
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  [type]="lineChartType">
          </canvas>
        </div>
      </ion-col>
      <ion-col class="hidden-lg-down" size="2"></ion-col>
    </ion-row>

    <p-table styleClass="sticky-table" [columns]="cols" [value]="stats" sortMode="multiple" [responsive]="true">
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: right">
          <span class="export">Export to:</span>
          <ion-button
            fill="outline"
            (click)="exportExcel()"
            style="margin-right: 0.5em"
          >Excel</ion-button>
          <ion-button
            fill="outline"
            (click)="exportPdf()"
          >
          PDF
          </ion-button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns;let last = last" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field ==='taxesTotal'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td [ngClass]="{'center-numbers-table-u_x_wider-padding': col.field ==='taxesTotal' ,'bold-text':  isStringField(stat[col.field])}" *ngFor="let col of columns">
            <!--span class="ui-column-title">{{ col.header }}</!--span-->
            {{col.field !== "timestamp" ?  (stat[col.field] | salonMonsterCurrency): (stat[col.field] | salonMonsterDate: 'ddd, MMMM D, Y')}}
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>

</ion-content>

